import React, { useState, useEffect } from "react";
import { db, auth } from "../config";
import { getDoc, doc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import apiClient from "../utils/apiClient";

export const authContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [loggedin, setLoggedIn] = useState(false);
  const [accountId, setAccountId] = useState("");
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const loadAccount = async () => {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);
          setAccountId(docSnap.data()?.accountId || "");
        };
        loadAccount();
        setLoggedIn(true);
      } else {
        setLoggedIn(false);
        setAccountId("");
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!accountId) {
      setTransactions([]);
      return;
    }

    let cancelled = false;

    const listTransactions = async () => {
      setLoading(true);
      try {
        const { data } = await apiClient.post("list-transactions", { limit: 20 });
        if (!cancelled) {
          setTransactions(data.transaction || []);
        }
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setTransactions([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    listTransactions();
    return () => {
      cancelled = true;
    };
  }, [accountId]);

  return (
    <authContext.Provider
      value={{
        loggedin,
        accountId,
        loading,
        transactions,
        setLoading,
      }}
    >
      {children}
    </authContext.Provider>
  );
};
